/**
 * Offer card init: SSR / WPFC HTML is the first term at the default party.
 * A different term already requotes. The same quote is required when the
 * listing URL party differs and the selected term index does not change.
 */

const partyAges = (ages) => {
  if (!Array.isArray(ages)) return [];
  return ages.map((value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : NaN;
  });
};

/** @param {{adults?: number, children?: number, ages?: number[]}} current */
/** @param {{adults?: number, children?: number, ages?: number[]}} next */
export const occupancyDiffersFromCard = (current, next) => {
  if (Number(current?.adults) !== Number(next?.adults)) return true;
  if (Number(current?.children) !== Number(next?.children)) return true;
  const left = partyAges(current?.ages);
  const right = partyAges(next?.ages);
  if (left.length !== right.length) return true;
  return left.some((age, index) => age !== right[index]);
};

/**
 * @param {{ termChanged?: boolean, occupancyChanged?: boolean }} state
 * @returns {boolean} true → same refresh as the term-change handler (quote + availability)
 */
export const shouldQuoteAfterOfferUrlHydrate = ({
  termChanged = false,
  occupancyChanged = false,
} = {}) => Boolean(termChanged || occupancyChanged);
